export const staticColours = {
  klmBlue: "#23a1dc",
  transaviaPurple: "#2800A0",
};
